import InputLoading from './input-loading';

export default InputLoading;